<template>
  <v-menu bottom rounded offset-y v-if="isUserImpersonated()">
    <template v-slot:activator="{ on }">
      <v-btn tile block v-on="on" elevation="0">
        <v-icon color="red" size="26">
          mdi-account-cowboy-hat-outline
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-list dense>
          <span v-for="(item, index) in impersonatedMenuItems">
            <v-list-item
              @click="item.action"
              :key="index"
              link
            >
              <v-icon color="red lighten-1" left>
                {{ item.icon }}
              </v-icon>
              <span class="body-2">
                {{ item.label }}
              </span>
            </v-list-item>
          </span>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import {isUserImpersonated, revertImpersonate} from "@/services/auth/impersonate";

export default {
  name: "ImpersonateMenu",
  methods: {isUserImpersonated},

  computed: {
    impersonatedMenuItems() {
      return [
        {
          label: this.$t('impersonate.revert'),
          show: true,
          icon: 'mdi-exit-to-app',
          action: revertImpersonate
        },
      ]
    },
  },
}
</script>
